<template></template>


<script>
import router from '@/router'
export default {
	name: 'checkLogin',
	data() {
		return {}
	},
	created: function () {
		let vm = this
		// if (localstorage) {

		let loginModel = JSON.parse(localStorage.getItem('USER_INFO'))
		if (
			loginModel != undefined &&
			loginModel.token != undefined &&
			loginModel != null
		) {
			this.axios.get('login/checkSign').then(function ({ data }) {
				if (data.result) {
					// data.data.initialPasswordNotChanged=true;
					debugger
					
					vm._globle.firstLoginKey =true;
					router.push({
						path: '/customs/talks',
					})
				} else {
					router.push({
						path: '/login',
					})
				}
			})
		} else {
			router.push({
				path: '/login',
			})
		}
		// } else {
		// 	this.$confirm('当前浏览器不支持，请更换浏览器', '提示', {
		// 		confirmButtonText: '确定',
		// 		showCancelButton: false,
		// 		type: 'warning'
		// 	})
		// 		.then(() => {
		// 			router.push({
		// 				path: '/login'
		// 			})
		// 		})
		// 		.catch(() => {
		// 			router.push({
		// 				path: '/login'
		// 			})
		// 		})
		// }
	},
}
</script>


// WEBPACK FOOTER //
// src/components/customer/checkLogin/checkLogin.vue